var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkAuthor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6482_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 10.8333C8.69186 11.3118 9.14845 11.7077 9.67278 11.9941C10.1971 12.2806 10.7769 12.4509 11.3729 12.4936C11.9688 12.5363 12.567 12.4503 13.1268 12.2415C13.6866 12.0327 14.1949 11.7059 14.6173 11.2833L17.1173 8.78335C17.8763 7.9975 18.2963 6.94499 18.2868 5.85251C18.2773 4.76002 17.8391 3.71497 17.0666 2.94243C16.294 2.1699 15.249 1.7317 14.1565 1.7222C13.064 1.71271 12.0115 2.13269 11.2257 2.89168L9.79232 4.31668",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6659 9.16665C11.308 8.68821 10.8514 8.29233 10.3271 8.00587C9.80274 7.7194 9.22293 7.54905 8.62698 7.50637C8.03103 7.46369 7.43287 7.54968 6.87307 7.7585C6.31327 7.96732 5.80493 8.29409 5.38252 8.71665L2.88252 11.2167C2.12353 12.0025 1.70355 13.055 1.71305 14.1475C1.72254 15.24 2.16075 16.285 2.93328 17.0576C3.70581 17.8301 4.75087 18.2683 5.84335 18.2778C6.93584 18.2873 7.98835 17.8673 8.77419 17.1083L10.1992 15.6833",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6482_576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAuthor);
export default __webpack_public_path__ + "static/media/link_author.2f4a8703f35da8a6f1b4e0673580fa11.svg";
export { ForwardRef as ReactComponent };